import { useEffect, useState } from "react";

export const WEBSITE_ORIGIN = (process.env.REACT_APP_WEBSITE_URL || "https://cas-media-website.pages.dev").replace(/\/$/, "");

export const SERVICE_STATIC_PATHS = {
  "advertising-and-branding": "/media/services/Advertising and Branding.png",
  "social-media-management": "/media/services/Social media manegement.png",
  "website-design-and-development": "/media/services/Website Design and development.PNG",
  "mobile-app-development": "/media/services/Mobile App Development.png",
  "game-development": "/media/services/Game Development.png",
  "animation-video-production": "/media/services/Animation video.png",
  "architecture-visualization": "/media/services/Architechture Visualization.PNG",
};

export function serviceStaticUrl(slug) {
  const path = SERVICE_STATIC_PATHS[slug];
  return path ? `${WEBSITE_ORIGIN}${encodeURI(path)}` : "";
}

/** Resolve relative site paths and dead API proxies for admin previews. */
export function resolveMediaUrl(src, fallback = "") {
  if (!src) return fallback || "";
  const value = String(src);
  if (fallback && value.includes("/api/media/public/")) return fallback;
  if (value.startsWith("/media/")) return `${WEBSITE_ORIGIN}${encodeURI(value)}`;
  return value;
}

export function mediaDisplaySrc(src, slug) {
  const fallback = serviceStaticUrl(slug);
  return resolveMediaUrl(src, fallback) || fallback;
}

export function ImgWithFallback({ src, fallback, alt = "", className }) {
  const initial = resolveMediaUrl(src, fallback) || fallback || "";
  const [current, setCurrent] = useState(initial);

  useEffect(() => {
    setCurrent(resolveMediaUrl(src, fallback) || fallback || "");
  }, [src, fallback]);

  if (!current) return null;

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      onError={() => {
        if (fallback && current !== fallback) setCurrent(fallback);
      }}
    />
  );
}
